export default "__VITE_ASSET__D4RmFRCH__"